import { Controller } from "stimulus";
import dispatchCustomEvent from "../../functions/dispatchCustomEvent.js";
import serializeForm from "../../functions/serializeForm";

export default class extends Controller {
  dispatchWithFormFields(event) {
    event.preventDefault();

    const queryString = serializeForm(this.element);

    dispatchCustomEvent(document, this._eventName(event), true, true, { queryString: queryString });
  }

  dispatch(event) {
    event.preventDefault();
    dispatchCustomEvent(document, this._eventName(event));
  }

  _eventName(event) {
    return event.target.dataset.eventName || this.element.dataset.eventName;
  }
}
